module.exports = __webpack_public_path__ + "static/media/default_banner_advertise.d1f0cd17.jpg";